import DrawingUtils from '../utils/DrawingUtils';

/**
 * Way(웨이포인트) 마커 및 경로 관리 Feature
 */
class WayFeature {
  constructor(createOverlay, map) {
    this.createOverlay = createOverlay;
    this.map = map;
    this.ways = {};
  }

  /**
   * Way 마커 및 경로 추가
   * @param {string} robotId - 로봇 ID
   * @param {Array} markers - 마커 정보 배열 [{ position, label, isRoi }, ...]
   * @param {string} color - 색상
   * @returns {Object} { markers, paths }
   */
  add(robotId, markers, color) {
    const markersForPaths = markers.filter(({ isRoi }) => !isRoi);

    this.ways[robotId] = {
      markers: DrawingUtils.drawWayMarkers(this.createOverlay, this.map, markers, color),
      paths: DrawingUtils.drawWayPaths(this.map, markersForPaths, color),
    };
    return this.ways[robotId];
  }

  /**
   * Way 마커 및 경로 제거
   * @param {string} robotId - 로봇 ID
   */
  remove(robotId) {
    if (!this.ways[robotId]) return;

    this.ways[robotId].markers.forEach((marker) => this.map.removeOverlay(marker));
    this.map.removeLayer(this.ways[robotId].paths);
    delete this.ways[robotId];
  }

  /**
   * Way 데이터 가져오기
   * @param {string} robotId - 로봇 ID
   * @returns {Object|undefined} Way 데이터
   */
  get(robotId) {
    return this.ways[robotId];
  }

  /**
   * 모든 Way 데이터 가져오기
   * @returns {Object} 모든 Way 데이터
   */
  getAll() {
    return this.ways;
  }
}

export default WayFeature;
